import script from "./BaseFleetComponent.vue?vue&type=script&lang=js"
export * from "./BaseFleetComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__